import React from 'react';
import PropTypes from 'prop-types';
import { Popover } from 'antd';
import { generateLinkDatas } from './utils';

/**
 * Link
 * @param children {node}
 * @param data {array}
 * @param pop {bool}
 * @returns {JSX.Element}
 */
const Link = ({ children, data = [], pop = false }) => {
  const content = generateLinkDatas(data);
  return (
    <>
      {pop && (
        <Popover
          content={
            <>
              {content}
              {children}
            </>
          }>
          <div>
            {content}
            {children}
          </div>
        </Popover>
      )}
      {!pop && (
        <>
          {content}
          {children}
        </>
      )}
    </>
  );
};

Link.propTypes = {
  children: PropTypes.node,
  data: PropTypes.array,
  pop: PropTypes.bool
};

export default Link;
